<template>
  <!-- 登录 -->
  <div class="login-contain lessonplay-shell">
    <!-- logo -->
    <div class="login-logo">
      <i class="login-logo-i"></i>
    </div>

    <!-- title -->
    <div class="title">
      <p>专注于实践能力训练的在线学习平台</p>
    </div>

    <!-- 手机号登录 -->
    <div class="box" v-if="login && !isRegister && !isForget">
      <!-- 登录模式 -->
      <div class="login-form">
        <div class="login-mode">
          <span>密码登录</span>
        </div>

        <!-- 下划线 -->
        <div class="underline">
          <hr />
        </div>

        <!-- 登录表单 -->
        <div class="form-wrapper">
          <a-input v-model="formState.username" class="form-input" placeholder="请输入手机号" autocomplete="“off”" />
          <a-input-password v-model="formState.pass" class="form-input" type="password" placeholder="请输入密码"
            autocomplete="“off”" />
          <a-button type="primary" html-type="submit" class="btn-form" :loading="logining"
            @click="handleFinish()">确认登录</a-button>
        </div>

        <!--  -->
        <div class="skip">
          <div @click="isRegister = true">注册账号</div>
          <div @click="isForget = true">忘记密码</div>
        </div>
      </div>

      <!-- 第三方登录 -->
      <div class="nonparty">
        <div class="nonparty-line">
          <hr />
        </div>

        <div class="nonparty-s">
          <span>第三方登录</span>
        </div>

        <div class="nonparty-line">
          <hr />
        </div>
      </div>
      <!-- 微信登录入口 -->
      <div class="login-wx-1">
        <div class="wx-btn-1" @click="changeLogin">
          <i class="wx-icon"></i>
          <span>微信登录</span>
        </div>
      </div>
    </div>
    <!-- 手机号注册 -->
    <div class="box" v-if="isRegister">
      <!-- 注册 -->
      <div class="register-form">
        <div class="register-mode">
          <span>注册账号</span>
        </div>

        <!-- 下划线 -->
        <div class="underline">
          <hr />
        </div>

        <!-- 注册表单 -->
        <div class="form-wrapper">
          <a-input v-model="formRegister.phone" class="form-input" placeholder="请输入手机号" />
          <div class="pass-box">
            <a-input v-model="formRegister.code" class="form-input" placeholder="请输入验证码" suffix />
            <!-- 倒计时 -->
            <span class="get-pass" v-if="codeShow" @click="getPhoneCode">获取验证码</span>
            <span class="get-pass" v-if="!codeShow">{{ count }}秒后重试</span>
          </div>
          <a-input-password v-model="formRegister.pass" type="password" class="form-input" placeholder="请输入密码"
            autocomplete="“true”" />
          <a-input-password v-model:value="formRegister.checkPass" type="password" class="form-input"
            placeholder="请再次输入密码" autocomplete="“true”" />
          <a-button type="primary" html-type="submit" class="btn-form" :loading="registering"
            @click="handleRegister">确认注册</a-button>
          <!-- 跳转使用手机号登录 -->
          <div class="return-login" @click="isRegister = false">返回登录</div>
        </div>
      </div>
    </div>
    <!-- 找回密码 -->
    <div class="box" v-if="isForget">
      <!-- 注册 -->
      <div class="register-form forget-from">
        <div class="register-mode">
          <span>找回密码</span>
        </div>

        <!-- 下划线 -->
        <div class="underline">
          <hr />
        </div>

        <!-- 找回密码 -->
        <!-- 手机号验证 -->
        <div class="form-wrapper" v-if="forgetStep == 1">
          <a-input v-model="formRegister.phone" class="form-input" placeholder="请输入手机号" />
          <div class="pass-box">
            <a-input v-model="formRegister.code" class="form-input" placeholder="请输入验证码" suffix />
            <!-- 倒计时 -->
            <span class="get-pass" v-if="codeShow" @click="getPhoneCode">获取验证码</span>
            <span class="get-pass" v-if="!codeShow">{{ count }}秒后重试</span>
          </div>
          <div class="single-form">
            <a-button type="primary" html-type="submit" class="btn-form" :loading="registering"
              @click="checkForget">下一步</a-button>
          </div>
          <div class="return-login" @click="forgetStep = 1; isForget = false;">返回登录</div>
        </div>
        <!-- 确认新密码 -->
        <div class="form-wrapper" v-if="forgetStep == 2">
          <a-input type="password" v-model="newPass.newpw" class="form-input" placeholder="请输入新密码" />
          <a-input type="password" v-model="newPass.confirmpw" class="form-input" placeholder="请再次输入新密码" />
          <div class="single-form">
            <a-button type="primary" html-type="submit" class="btn-form" :loading="editPasswording"
              @click="editPassword">确认</a-button>
          </div>
          <div class="return-login" @click="forgetStep = 1; isForget = false;">返回登录</div>
        </div>
      </div>
    </div>

    <!-- 微信登录 -->
    <div class="box" :class="{ hide: !loginWx }">
      <!-- 微信登录二维码 -->
      <div id="wx-login-qrCode"></div>
      <!-- 跳转使用手机号登录 -->
      <div class="return-login">
        <span @click="changeLogin">使用手机号登录</span>
      </div>
    </div>

    <!-- 页脚 -->
    <!-- <div class="bottom-content">
        <div class="bottom-item">
          <span>超级教案</span>
          <span>黔ICP备18006806号-1</span>
        </div>
        <div class="bottom-item">
          <i class="icon-police"></i>
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52990002000053">贵公网安备52990002000053号</a>
        </div>
    </div>-->
  </div>
</template>

<script>
import { PASSPORT_SERVER } from '@/config/url';
import { defineComponent, getCurrentInstance, reactive, ref, onMounted } from 'vue';
import { PC_APPID, SCOPE } from '@/config/wx';
import { addQueryString } from '@/util/url';

export default defineComponent({
  setup() {
    const logining = ref(false);
    const isRegister = ref(false);
    const isForget = ref(false);
    const forgetStep = ref(1);
    const registering = ref(false);
    const codeShow = ref(true);
    const editPasswording = ref(false);
    const count = ref(60);
    const redirectURI = ref('');
    const userGuid = ref('');

    const { proxy } = getCurrentInstance();

    const formRef = ref();
    const formState = reactive({
      username: '',
      pass: '',
      code: ''
    });
    const formRegister = reactive({
      phone: '',
      code: '',
      pass: '',
      checkPass: "",
      codeGuid: ""
    });
    const newPass = reactive({
      userGuid: '',
      newpw: '',
      confirmpw: ''
    });

    // 生命周期钩子
    onMounted(async () => {
      const search = new URLSearchParams(location.search)
      redirectURI.value = search.get('redirectURI') || 'https://ican.lessonplan.cn';
      //验证本地token
      const verifyRet = await proxy.$api.passport.verifyToken()
      if (verifyRet.status === 1) location.href = addQueryString(redirectURI.value, 'token', verifyRet.token);

      changeFavicon('https://img.lessonplan.cn/IMG/LessonPlay/public/ican.ico');
      //修改标签图标
      function changeFavicon(link) {
        let $favicon = document.createElement("link");
        $favicon.rel = "icon";
        $favicon.href = link;
        document.head.appendChild($favicon);
      }
    })

    ///////////////////////登录
    // 表单验证规则
    const rules = {
      username: [{
        required: true, message: '手机号不能为空', trigger: 'blur'
      }],
      pass: [{
        required: true, message: '密码不能为空', trigger: 'change',
      }],
    };
    const layout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 15 },
    };

    // 登录
    const handleFinish = async () => {
      let msg = '';
      if (!formState.username || !formState.pass) msg = '请输入正确的账号密码';
      if (msg) return proxy.$message.warning(msg);

      logining.value = true;
      //登录
      let res = await proxy.$api.passport.auth({ username: formState.username, password: formState.pass });

      if (res.status != 1) {
        logining.value = false;
        return proxy.$message.warning("账号或密码错误");
      }
      let { token } = res;

      proxy.$message.success('登陆成功');

      location.href = addQueryString(redirectURI.value, 'token', token);
    };
    // 登录切换
    const login = ref(true)
    const loginWx = ref(false)
    const changeLogin = () => {
      login.value = !login.value;
      loginWx.value = !loginWx.value;
      wxloginForPC()
    };
    //生成登录二维码
    const wxloginForPC = async () => {
      const wxApiRedirectURI = `${PASSPORT_SERVER}/wx/client_strict?redirectURI=${redirectURI.value}`
      //eslint-disable-next-line
      new WxLogin({
        id: 'wx-login-qrCode',
        appid: PC_APPID,
        scope: SCOPE,
        redirect_uri: encodeURIComponent(wxApiRedirectURI),
        href: 'https://cdn.lessonplan.cn/Public/CSS/wx-login-style(white).css',
        fast_login: 1,
      })
    };

    /////////////////////////////////////注册
    //获取验证码
    const getPhoneCode = async () => {
      if (!formRegister.phone || formRegister.phone.length != 11) return proxy.$message.warning('请先输入正确的手机号');
      codeShow.value = false;
      count.value = 60;
      count.value -= 1;
      let countTime = setInterval(() => {
        count.value -= 1;
        if (count.value == 0) {
          clearInterval(countTime);
          codeShow.value = true;
        }
      }, 1000);
      proxy.$message.success('短信已发送，请注意查收');

      let res = await proxy.$api.account.sendSms(formRegister.phone);
      if (res.code != 1) return proxy.$message.error(res.msg);
      formRegister.codeGuid = res.data.PK_CodeGuid;
    };
    //提交注册
    const handleRegister = async () => {
      let msg = '';
      if (formRegister.pass == "") msg = '请输入密码';
      else if (formRegister.pass.length < 6) msg = '密码不小于6位';
      else if (formRegister.checkPass == "") msg = '请再次输入密码';
      else if (formRegister.checkPass != formRegister.pass) msg = '两次密码不一致';
      else if (!formRegister.codeGuid) msg = '请先获取验证码';
      if (msg) return proxy.$message.warning(msg);

      registering.value = true;
      //先验证验证码
      let res = await proxy.$api.account.checkcode(formRegister.codeGuid, formRegister.code);
      if (res.code != 1) {
        formRegister.codeGuid = '';
        formRegister.code = '';
        registering.value = false;
        return proxy.$message.error(res.msg);
      }

      let cres = await proxy.$api.account.register({ Name: formRegister.phone, Phone: formRegister.phone, Password: formRegister.checkPass });
      registering.value = false;
      if (cres.status != 1) {
        formRegister.codeGuid = '';
        formRegister.code = '';
        return proxy.$message.error(cres.err);
      }
      proxy.$message.success('注册成功');
      isRegister.value = false;
    }
    //验证忘记密码
    const checkForget = async () => {
      let msg = ``;
      if (!formRegister.phone || formRegister.phone.length != 11) msg = '请输入正确的手机号';
      else if (!formRegister.codeGuid) msg = '请先获取验证码';
      if (msg) return proxy.$message.warning(msg);
      registering.value = true;
      //找到用户
      let userList = await proxy.$api.account.getClientByUser(formRegister.phone).then(res => res.data || []);
      if (userList.length == 0) {
        registering.value = false;
        return proxy.$message.warning("未找到该用户，请确认手机号是否正确");
      }
      userGuid.value = userList[0].PK_UserGuid;
      //先验证验证码
      let res = await proxy.$api.account.checkcode(formRegister.codeGuid, formRegister.code);
      registering.value = false;

      formRegister.codeGuid = '';
      formRegister.code = '';
      formRegister.phone = '';
      if (res.code != 1) return proxy.$message.error(res.msg);

      forgetStep.value = 2;
    }
    //修改密码
    const editPassword = async () => {
      if (editPasswording.value) return;
      let password = newPass;

      let msg = '';
      for (const key in password) {
        if (password[key] && typeof (password[key]) === 'string') password[key] = password[key].trim();
      }
      if (!password.newpw) msg = '请输入新密码';
      else if (password.newpw.length < 6) msg = '请至少输入6位密码';
      else if (!password.confirmpw) msg = '请再次输入新密码';
      else if (password.newpw != password.confirmpw) msg = '两次输入的密码不一致';

      if (msg) return proxy.$message.warning(msg);

      editPasswording.value = true;
      let res = await proxy.$api.account.setNewPassword({
        PK_UserGuid: this.userGuid,
        Password: password.newpw
      });
      editPasswording.value = false;

      if (res.status != 1) return proxy.$message.error(res.message);

      proxy.$message.success('密码重置成功');
      forgetStep.value = 1;
      isForget.value = false;
    }

    return {
      logining,
      registering,
      formState,
      formRef,
      formRegister,
      rules,
      layout,
      login,
      loginWx,
      isRegister,
      isForget,
      forgetStep,
      count,
      codeShow,
      newPass,
      editPasswording,
      editPassword,
      handleFinish,
      changeLogin,
      getPhoneCode,
      handleRegister,
      checkForget
    };
  }
});

</script>
<style scoped lang="scss">
@import "./login.scss";
</style>